import type { ReactNode } from 'react';
import { hasMinRole, useRole } from '../lib/roleContext';

interface RoleGateProps {
  require: 'design' | 'admin';
  children: ReactNode;
  fallback?: ReactNode;
}

export function RoleGate({ require: minRole, children, fallback }: RoleGateProps) {
  const { role, loading } = useRole();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full text-vari-gray text-sm">
        Loading…
      </div>
    );
  }

  if (!hasMinRole(role, minRole)) {
    return fallback ? <>{fallback}</> : <AccessDenied />;
  }

  return <>{children}</>;
}

function AccessDenied() {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center space-y-2 max-w-sm px-6">
        <p className="text-lg font-semibold text-vari-navy">Access Denied</p>
        <p className="text-sm text-vari-gray">
          You don't have permission to view this page.
        </p>
      </div>
    </div>
  );
}
